var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Main-Content",attrs:{"id":"AccountSharedRulesetsList"}},[_c('Page',{attrs:{"title":_vm.$t('Shared Rulesets'),"primaryAction":{
      label: _vm.$t('AccountSharedRulesets.New Ruleset'),
      onAction: function () { return _vm.createRuleset(); },
      disabled: _vm.saving
    },"secondaryActions":[{
      label: _vm.$t('Notes'),
      onAction: function () { return _vm.eventHub.$emit('showAccountNotes', 'SHAREDRULESET'); }
    }]}},[(_vm.loading)?_c('LoadingLayout'):_vm._e(),(!_vm.loading)?_c('Layout',[_c('LayoutSection',[_c('Card',[_c('Filters',{attrs:{"query":_vm.query},on:{"update:query":function($event){_vm.query=$event}}}),_c('DataTable',{attrs:{"columns":[
              {
                key: 'name',
                label: _vm.$t('Ruleset'),
                sortable: true,
                fixed: true
              },
              {
                key: 'rulesLength',
                label: _vm.$t('Rules')
              },
              {
                key: 'references',
                label: _vm.$t('References')
              },
              {
                key: 'updatedOn',
                label: _vm.$t('Last Updated'),
                format: 'dateLong',
                sortable: true
              }
            ],"row-actions":[
              {
                label: _vm.$t('Rename'),
                onAction: function (row) { return _vm.renameRuleset(row); },
                disabled: _vm.saving
              },
              {
                label: _vm.$t('Copy'),
                onAction: function (row) { return _vm.copyRuleset(row); },
                disabled: _vm.saving
              },
              {
                label: _vm.$t('Delete'),
                onAction: function (row) { return _vm.deleteRuleset(row); },
                disabled: _vm.saving
              }
            ],"rows":_vm.formattedRulesets,"sort":_vm.sortBy,"pagination":{
              offset: _vm.offset,
              limit: _vm.limit,
              total: _vm.formattedRulesets.length,
              updateOffset: function (val) { return _vm.offset = val; },
              updateLimit: _vm.updateLimit
            }},on:{"update:sort":function($event){_vm.sortBy=$event}},scopedSlots:_vm._u([{key:"col:name",fn:function(ref){
            var row = ref.row;
return [_c('PageLink',{attrs:{"href":("/#/account/sharedRulesets/edit/" + (row.id))}},[_vm._v(_vm._s(row.name))])]}},{key:"col:references",fn:function(ref){
            var row = ref.row;
return [(row.references)?_c('PageLink',{on:{"click":function($event){return _vm.showModal(row)}}},[_vm._v(_vm._s(row.references))]):[_vm._v(_vm._s(_vm.$t('Not in use')))]]}}],null,false,998175564)})],1)],1)],1):_vm._e()],1),(_vm.modalRuleset)?_c('Modal',{attrs:{"title":_vm.$t('AccountSharedRulesets.rulesetReferences', { name: _vm.modalRuleset.name}),"visible":!!_vm.modalRuleset},on:{"close":function($event){_vm.modalRuleset = null}}},[_c('Layout',[_c('LayoutSection',[_c('Card',{staticClass:"modal-card"},[_c('DataTable',{attrs:{"columns":[
            {
              label: _vm.$t('Campaigns'),
              key: 'name'
            },
            {
              label: _vm.$t('Segments'),
              key: 'segments'
            }
          ],"rows":_vm.formattedCampaignSegments},scopedSlots:_vm._u([{key:"col:name",fn:function(ref){
          var row = ref.row;
return [_c('a',{attrs:{"href":("/#/campaigns/" + (row.id)),"target":"_blank"}},[_vm._v(_vm._s(row.name))])]}},{key:"col:segments",fn:function(ref){
          var row = ref.row;
return [_c('List',{attrs:{"tight":""}},_vm._l((row.segments),function(seg){return _c('ListItem',{key:seg.id},[_c('a',{attrs:{"href":("/#/campaigns/" + (row.id) + "/segmentation/segment/" + (seg.id)),"target":"_blank"}},[_vm._v(_vm._s(seg.name))])])}),1)]}}],null,false,984611939)})],1)],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }